import React from "react";

export const Stat = ({ label, value, good, bad }) => (
  <div className="tactical-card">
    <p className="tac-label">{label}</p>
    <p className={`font-mono text-lg mt-0.5 ${bad ? "text-[var(--danger)]" : good ? "text-[#7FBA9D]" : "text-bone"}`}>
      {value}
    </p>
  </div>
);

export const Loading = () => (
  <div className="min-h-screen flex items-center justify-center text-bone tac-label">
    SUMMONING...
  </div>
);
